<template>
  <div id="costs" class="bg-gray-100">
    <img class="w-100percent mt--2" src="@/assets/images/wave2.svg"/>
    <div class="pt-24 pb-20 container-wide mx-auto">
      <h6 class="text-secondary-500">
        —  Costs
      </h6>

      <h2 class="mt-2 max-w-screen-sm">
        First Options Fertility will set you on the correct path to taking control of your fertility.
      </h2>

      <div class="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 mt-10">
        <ServiceCard
          title="Standard Semen Assessment"
          body="Receive a complete standard semen assessment, written report and private consultation."
          footer="Subsequent semen assessments will cost €120."
          price="€150"
        />

        <ServiceCard
          title="Semen Oxidative Stress Test (SOS)"
          body="A cost effective way of assessing antioxidant imbalance in semen which can impact fertility. Results returned the same day as the test."
          footer=""
          price="€120"
        />

        <div class="service-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-medium text-lg leading-tight mb-3">
              Semen Assessment <span class="text-secondary-500 font-medium">PLUS+</span>
            </p>
          </div>

          <p class="text-primary-500 font-medium text-2xl">
            €250
          </p>

          <p class="text-gray-700 mt-4">
            For the most cost effective and thorough initial semen assessment available on the market combine SOS with a standard semen assessment. This package is most suitable for couples who are at the early stages of fertility investigations. It enables an efficient, cost-effective, thorough semen examination with same day results including phone consultation.
          </p>
        </div>


      </div>

      <div class="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 mt-4">
        <div class="service-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-medium text-lg leading-tight mb-3">
              Sperm DNA Fragmentation
            </p>
          </div>

          <p class="text-primary-500 font-medium text-2xl">
            From €350
          </p>

          <p class="text-gray-700 mt-4">
            Choose from 1 of 2 providers.
            <ul class="list-disc ml-6 my-2">
              <li>COMET assay by EXAMEN Labs - €550 </li>
              <li>SCSA by SPZ labs - €450</li>
              <li>TUNEL assay by IBBiotech available by request to info@firstoptionsfertility.ie - €350</li>
            </ul>
             Pricess include the DNA fragmentation test and standard semen assessment.<br><br>
             For more details email <a class="text-secondary-500" href="mailto:info@firstoptionsfertility.ie">info@firstoptionsfertility.ie</a> or phone <a class="text-secondary-500" href="tel:+353874414492">+353874414492</a>
          </p>
        </div>

        <div class="service-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-medium text-lg leading-tight mb-3">
              Semen Culture and Sensitivity Testing
            </p>
          </div>

          <p class="text-primary-500 font-medium text-2xl">
            €100
          </p>

          <p class="text-gray-700 mt-4">
            A test which checks for the presence of microorganisms in semen.
            For your convenience the semen sample for testing can be produced at home and you do not need to attend the clinic.<br><br>
             For more details email <a class="text-secondary-500" href="mailto:info@firstoptionsfertility.ie">info@firstoptionsfertility.ie</a> or phone <a class="text-secondary-500" href="tel:+353874414492">+353874414492</a><br><br>
             This test can be <a class="text-secondary-500" href="https://calendly.com/firstoptionsfertility/60min">booked online here</a>
          </p>
        </div>

        <div class="service-card rounded-md p-5">
          <div class="flex items-baseline justify-between">
            <p class="font-medium text-lg leading-tight mb-3">
              Post Vasectomy Semen Testing (PVSA)
            </p>
          </div>

          <p class="text-gray-700">
            <span class="text-primary-500 font-medium text-2xl">€</span> vary for postal or on-site sample production.
          </p>

          <p class="text-gray-700 mt-4">
           For more details email info@firstoptionsfertility.ie
          </p>
        </div>

      </div>

      <div class="flex justify-center">
        <AppButton class="mt-12 primary align-center"
          link="https://calendly.com/firstoptionsfertility"
          msg="Make an Appointment"
          target="_blank"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ServiceCard from './ui/ServiceCard.vue'
import AppButton from './ui/AppButton.vue'

export default {
  name: 'StarterServices',
  components: {
    ServiceCard,
    AppButton
  },
}
</script>

<style scoped>
.service-card  {
  @apply bg-white;
}

.rounded-full {
  @apply bg-gray-100;
}
</style>
